export const emptyGridPresets = {
    page: {},
};
//# sourceMappingURL=grid.js.map